import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

class Poster extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      posterLoaded: false,
      posterSolutionLoaded: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.movie !== this.props.movie) {
      this.setState({
        posterLoaded: false,
        posterSolutionLoaded: false,
      });
    }
  }

  handleOnLoadPoster = () => {
    this.setState({
      posterLoaded: true
    })
  }

  handleOnLoadPosterSolution = () => {
    this.setState({
      posterSolutionLoaded: true
    })
  }

  render() {
    const movie = this.props.movie;
    const displayAnswer = this.props.displayAnswer;
  
    const posterLoaded = this.state.posterLoaded;
    const posterSolutionLoaded = this.state.posterSolutionLoaded;

    const areLoaded = (posterLoaded && posterSolutionLoaded);

    const poster = movie.poster;
    const posterSolution = movie.poster_solution;

    return(
      <span>
        <span className={areLoaded ? "invisible" : "visible"}>
          <CircularProgress />
        </span>
        <span>
          <img className={(areLoaded && !displayAnswer) ? "visible" : "invisible"} alt="poster" src={poster} onLoad={this.handleOnLoadPoster} />
          <img className={(areLoaded && displayAnswer) ? "visible" : "invisible"} alt="solution" src={posterSolution} onLoad={this.handleOnLoadPosterSolution} />
        </span>
      </span>
    );
  }
}

export default Poster;
